import React, { useState } from 'react';
import CyberpunkPortfolio from '../components/portfolio/CyberpunkPortfolio';

const Home = () => {
  const [activeSection, setActiveSection] = useState('bio');
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  // Close menu when clicking outside
  React.useEffect(() => {
    const handleClickOutside = (event) => {
      if (isMenuOpen && !event.target.closest('nav') && !event.target.closest('button')) {
        setIsMenuOpen(false);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [isMenuOpen]);

  return (
    <CyberpunkPortfolio
      activeSection={activeSection}
      setActiveSection={setActiveSection}
      isMenuOpen={isMenuOpen}
      setIsMenuOpen={setIsMenuOpen}
    />
  );
};

export default Home;